import React from 'react'
import ImageGallery from 'react-image-gallery';
import ImageSlider from './ImageSlider';

const GalleryComponent = () => {

    const images = [
        {
          original: 'https://picsum.photos/id/1018/1000/600/',
          thumbnail: 'https://picsum.photos/id/1018/250/150/',
        },
        {
          original: 'https://picsum.photos/id/1015/1000/600/',
          thumbnail: 'https://picsum.photos/id/1015/250/150/',
        },
        {
          original: 'https://picsum.photos/id/1019/1000/600/',
          thumbnail: 'https://picsum.photos/id/1019/250/150/',
        },
      ];
 
      
    return (
        <div>
          <ImageSlider />
          {/* <hr/>
            <ImageGallery 
                lazyLoad={true}
                showPlayButton={false}
                showBullets={true}
                autoPlay={false}
                showIndex={true}
                showThumbnails={false}
                slideOnThumbnailOver={true}
                showFullscreenButton={false}
                onClick={(event)=> console.log(event.target.src)}
                items={images} /> */}
              
        </div>
    )
}


export default GalleryComponent;